import React from 'react';

// Shown while a page's code is downloading. Kept tiny because it ships in the main bundle.
export default function PageLoading({ fullScreen = false }) {
	return (
		<div className={`flex items-center justify-center w-full ${fullScreen ? 'h-screen' : 'min-h-[60vh]'}`} aria-busy="true" aria-label="Loading page">
			<div className="w-9 h-9 rounded-full border-[3px] border-[#E5F9F2] border-t-[#00BA77] animate-spin" />
		</div>
	);
}
